import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import LocalShipping from '@material-ui/icons/LocalShipping';
import SpacingStyles from '../../../styles/helpers/spacing';
import TypographyStyles from '../../../styles/typography';
import combineStyles from '../../../utils/combineStyles';
import classnames from 'classnames';
import { formatDateTime } from './../../../utils/DateTime';

const styles = theme => ({
  iconContainer: {
    position: 'absolute',
    left: 0,
    top: -8,
    width: '32px',
    height: '32px',
    backgroundColor: '#E0F3FE',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  iconRoot: {
    fontSize: '14px'
  },
  activityDetail: {
    position: 'relative',
    display: 'inline-block',
    alignSelf: 'stretch'
  },
  activityName: {
    marginTop: [theme.spacing.unit * 1.5, '!important'],
    marginBottom: [theme.spacing.unit * 0.625, '!important']
  },

  itemContainer: {
    display: 'flex',
    justifyContent: 'flex-start',
    paddingBottom: theme.spacing.unit * 5,
    paddingLeft: theme.spacing.unit * 6,
    position: 'relative'
  },
  verticalLine: {
    width: 1,
    height: '100%',
    borderRight: '1px dashed rgba(12,31,44,0.12);',
    position: 'absolute',
    left: 16
  }
});
export class Item extends PureComponent {
  static propTypes = {
    activity: PropTypes.object.isRequired
  };
  render() {
    const { classes, activity } = this.props;
    return (
      <div className={classes.itemContainer}>
        <div className={classes.verticalLine} />
        <div className={classes.iconContainer}>
          <LocalShipping color="primary" classes={{ root: classes.iconRoot }} />
        </div>
        <div className={classes.activityDetail}>
          <h4
            className={classnames(
              classes.noMargin,
              classes.caption,
              classes.boldWeight
            )}
          >
            {formatDateTime(activity.createdUtc)}
          </h4>

          <h5 className={classnames(classes.subtitle3, classes.activityName)}>
            {activity.title}
          </h5>
          <p className={classes.body2}>{activity.actualUser}</p>
        </div>
      </div>
    );
  }
}
export default withStyles(
  combineStyles(styles, TypographyStyles, SpacingStyles)
)(Item);
